// @ts-check
import api from 'utils/api';
import { decamelizeKeys } from 'humps';

const actions = {
  fetchPreferences() {
    return api
      .get('/agent_portal/api/current_agent/notification_preferences')
      .then(response => response.data);
  },

  savePreferences(formValues) {
    return api.put(
      '/agent_portal/api/current_agent/notification_preferences',
      decamelizeKeys(formValues)
    );
  },
};

export default actions;
